module.exports = __webpack_public_path__ + "img/panel13.7f411a9f.jpg";